import { render } from "./NewEmptyPackage.vue?vue&type=template&id=72282e1a&scoped=true&ts=true"
import script from "./NewEmptyPackage.vue?vue&type=script&lang=ts"
export * from "./NewEmptyPackage.vue?vue&type=script&lang=ts"

import "./NewEmptyPackage.vue?vue&type=style&index=0&id=72282e1a&scoped=true&lang=css"

import exportComponent from "P:\\roboworks\\easyros\\easyros\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72282e1a"]])

export default __exports__